import Typography from "@mui/material/Typography";
import { tokens } from "../../design-system/tokens";

export type ErrorMessageSize = "small" | "medium" | "large" | "xl";

export type ErrorMessageProps = {
  message?: string | null;
  size?: ErrorMessageSize;
};

function getSizeStyles(size: ErrorMessageSize) {
  const borderRadius =
    size === "small"
      ? tokens.borderRadius.md
      : size === "medium"
        ? tokens.borderRadius.lg
        : tokens.borderRadius.xl;

  const padding =
    size === "xl"
      ? "10px 14px"
      : size === "large"
        ? "8px 12px"
        : size === "medium"
          ? "8px 10px"
          : "5px 8px";

  const typography =
    size === "small"
      ? tokens.typography.caption
      : size === "large"
        ? tokens.typography.body
        : size === "xl"
          ? tokens.typography.bodyLarge
          : tokens.typography.bodySmall;

  const marginTop =
    size === "small" ? 0.25 : size === "xl" ? 0.75 : 0.5;

  return { borderRadius, padding, typography, marginTop };
}

export default function ErrorMessage({
  message,
  size = "medium",
}: ErrorMessageProps) {
  if (!message) {
    return null;
  }

  const { borderRadius, padding, typography, marginTop } = getSizeStyles(size);

  return (
    <Typography
      sx={{
        ...typography,
        color: tokens.colors.error,
        bgcolor: "rgba(229, 62, 62, 0.08)",
        border: `1px solid ${tokens.colors.error}`,
        borderRadius,
        p: padding,
        mt: marginTop,
      }}
    >
      {message}
    </Typography>
  );
}
